module.exports = __webpack_public_path__ + "img/icon_agent.2b752023.png";